import { Model } from 'pinia-orm';
import { Attr, BelongsTo, HasMany, HasManyThrough, Num, Str } from 'pinia-orm/dist/decorators';
import Claim from './Claim';
import MonthlyScopeGapForecast from './MonthlyScopeGapForecast';
import Package from './Package';
import Project from './Project';
/* --- user header --- */
import { DateTime } from 'luxon';
import ScopeGapCategory from './ScopeGapCategory';
import ScopeGapItem from './ScopeGapItem';
/* --- end user header --- */

export default class ScopeGap extends Model {
  static entity = 'App\\Models\\ScopeGap';
  // fields
  @Num(0)
  declare id: number;
  @Num(0)
  declare package_id: number;
  @Num(0)
  declare project_id: number;
  @Num(0)
  declare claim_id: number | undefined;
  @Str('')
  declare start_date: string;
  @Str('')
  declare end_date: string;
  @Num(0)
  declare sort_order: number;
  @Str('')
  declare created_at: string;
  @Str('')
  declare updated_at: string;
  // relations
  @BelongsTo(() => Package, 'package_id', 'id')
  declare package: Package;
  @BelongsTo(() => Project, 'project_id', 'id')
  declare project: Project;
  @BelongsTo(() => Claim, 'claim_id', 'id')
  declare claim: Claim;
  @HasManyThrough(() => ScopeGapItem, () => MonthlyScopeGapForecast, 'scope_gap_id', 'id', 'id', 'scope_gap_item_id')
  declare scope_gap_items: ScopeGapItem[];
  @HasMany(() => MonthlyScopeGapForecast, 'scope_gap_id', 'id')
  declare monthly_forecasts: MonthlyScopeGapForecast[];
  @HasMany(() => ScopeGapCategory, 'package_id', 'package_id')
  declare categories: ScopeGapCategory[];
  @Attr(undefined)
  declare $total_forecast: number;
  @Attr(undefined)
  declare $total_final_amount: number;
  /* --- user code --- */

  public get monthLabel(): string {
    return DateTime.fromISO(this.start_date).toFormat('MMM-yy');
  }

  public get totalForecast(): number {
    return this.$total_forecast;
  }

  public get totalFinalAmount(): number {
    return this.$total_final_amount ?? 0;
  }

  /* --- end user code --- */
}
